import {InjectionToken} from '@angular/core';

export interface InstrumentationConfig {
  ignoreUrls: string[];
  applicationInsightsConnectionString?: string;
  appId?: string;
  appVersion?: string;
}

export const INSTRUMENTATION_CONFIG
               = new InjectionToken<InstrumentationConfig>('instrumentation.config');

export const INSTRUMENTATION_CONFIG_DEFAULT
               = new InjectionToken<InstrumentationConfig>('instrumentation.config.default');
